import styled from "styled-components";
import { message, Typography } from "antd";
import { AllLogoBig, RefreshIcon} from "../../../../assets/PaymentIcon";
import api from "../../../../api/api";
import SwitchToAutoPaymentModal from "./SwitchToAutoPaymentModal";
import { useState } from "react";
import AutoPaymentModalError from "./AutoPaymentModalError";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  justify-content:center;
  flex-direction: column;
  align-items: center;
  gap: 25px;
  height:100vh;
`;


const SubText = styled(Typography)`
  font-size: 16px;
  font-weight: 400;
  color: #868686;
  text-align: center;
`;
const BlurContainer = styled.div`
 position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  z-index: 999;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);

  display: flex;
  justify-content: center;
  align-items: center;
`;

const PayTypeSwapButton = styled.div`
 width: fit;
 height: 48px;
 padding: 12px;
 border-radius: 8px;
 background-color:#1859FF;
display:flex;
justify-content:center;
align-items:center;
gap: 10px;
color: #fff;
font-size:16px;
cursor:pointer;
`

const BlueText = styled.h3`
 font-size: 16px;
  font-weight: 400;
  color: #1859FF;
  text-align: center;
`


const SwapPaymentAutoManual = ({setSuccessRecall,successRecall}) => {

  const [open, setOpen] = useState(false);
  const [errorOpen,setErrorOpen] = useState(false);
  const [errorMessage,setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

    const handleSwitchPaymentToManual = () => {
         setLoading(true);
         const payload = {
            "payment_method": "MANUAL" //AUTO, MANUAL
         };
         api
      .SwitchPaymentMethod(payload)
      .then(() => {
        message.success("Switch Payment Method Successfully");
       setLoading(false);
       setOpen(false);
       setSuccessRecall(!successRecall)
      })
      .catch((err) => {
        setLoading(false);
        setOpen(false);
       setErrorOpen(true);
       setErrorMessage(err);
        // message.error(err);
      });
    }

    const navigate = useNavigate();

    const {t} = useTranslation();

  return (
     <BlurContainer>
         <Container>
           <AllLogoBig />
           <Typography style={{ fontSize: "24px", fontWeight: "400",color:"#191114"}}>
            {t('your_store_auto_payment')}
           </Typography>
           <SubText>
           {t('by_changing_payment_type')}
           </SubText>
           <PayTypeSwapButton onClick={() => setOpen(true)}>
            {t('change_to_manual')}
            <RefreshIcon/>
           </PayTypeSwapButton>
           <BlueText style={{cursor:"pointer"}} onClick={() => {
            navigate("/home/dashboard");
           window.location.reload();
           }}>
           {t('never_mind')}
           </BlueText>
         </Container>
          <SwitchToAutoPaymentModal
        open={open}
        onCancel={() => setOpen(false)}
        onConfirm={handleSwitchPaymentToManual}
        loading={loading}
      />
       <AutoPaymentModalError
        open={errorOpen}
        onCancel={() => setErrorOpen(false)}
        errorMessage={errorMessage}
      />
       </BlurContainer>
  )
}

export default SwapPaymentAutoManual
